import styled from 'styled-components';

export const PillWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  button {
    margin-right: 0;
  }
`;

export const CardTitle = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const AddExistingGuestsWrapper = styled.div<{ withTopMargin?: boolean }>`
  margin-top: ${({ withTopMargin }) => (withTopMargin ? '20px' : '0')};
  margin-bottom: 20px;
`;
